import { LifesHubColors, chartValueLabelStyle } from 'src/utils/views'
import { formatNumber } from './tcm_view_utils'

export const ChartPalette = {
    series: LifesHubColors.chartBase,
    emphasis: LifesHubColors.chartEmphasis,
    selected: LifesHubColors.warning,
    label: LifesHubColors.muted,
    valueLabel: chartValueLabelStyle.color,
    axisLine: LifesHubColors.border,
    gridLine: LifesHubColors.gridLine,
    multi: [LifesHubColors.chartEmphasis, LifesHubColors.blue, LifesHubColors.warning, LifesHubColors.muted2]
}

export const ChartFontSize = {
    axis: 11.5,
    axisDense: 10,
    value: 11.5
}

export const axisLabelStyle = {
    color: ChartPalette.label,
    fontSize: ChartFontSize.axis
}

export const axisLineStyle = {
    lineStyle: { color: ChartPalette.axisLine }
}

export const splitLineStyle = {
    lineStyle: { color: ChartPalette.gridLine }
}

export const tooltipStyle = {
    appendToBody: true,
    valueFormatter: (value: unknown) => formatNumber(Number(value)),
    backgroundColor: '#ffffff',
    borderColor: LifesHubColors.border,
    borderWidth: 1,
    padding: [8, 10] as [number, number],
    textStyle: { color: LifesHubColors.ink, fontSize: 12 },
    extraCssText: 'border-radius: 10px; box-shadow: 0 20px 70px rgba(0, 0, 0, .24);'
}

export function seriesColor(selected: boolean | undefined) {
    return selected ? ChartPalette.selected : ChartPalette.series
}
